(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('HospitalizationDischargeToDeleteController',HospitalizationDischargeToDeleteController);

    HospitalizationDischargeToDeleteController.$inject = ['$uibModalInstance', 'entity', 'HospitalizationDischargeTo'];

    function HospitalizationDischargeToDeleteController($uibModalInstance, entity, HospitalizationDischargeTo) {
        var vm = this;

        vm.hospitalizationDischargeTo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            HospitalizationDischargeTo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
